export const DocumentsTypes = [
    {
        value: "internal",
        title: "Internal"
    },
    {
        value: "external",
        title: "External"
    }
];

export const DocumentsCategoryTypes = [
    {
        value: "Data Processing Agreement",
        title: "Data Processing Agreement"
    },
    {
        value: "TOM",
        title: "TOM"
    },
    {
        value: "Certificates",
        title: "Certificates"
    },
    {
        value: "Privacy Statement",
        title: "Privacy Statement"
    },
    {
        value: "Audit Reports",
        title: "Audit Reports"
    },
    {
        value: "Other",
        title: "Other"
    },
];

export const DocumentsConfidentialityLevels = [
    {
        value: "public",
        title: "Public"
    },
    {
        value: "internal",
        title: "Internal"
    },
    {
        value: "restricted",
        title: "Restricted"
    },
    {
        value: "confidential",
        title: "Confidential"
    }
];